import { Fragment, memo } from 'react'
import PropTypes from 'prop-types'
import { Button, Text } from '@leroy-merlin-br/backyard-react-ui'

import IconDepartment from 'reactGarden/IconsDepartment'

import { isLink } from 'lmcv/modules/utils'
import { Icon } from 'lmcv/components/Icon'

import * as S from './styled'

function CouponNew ({
  image,
  title,
  description,
  category,
  buttonText,
  footerText,
  giftedBy,
  isShared,
  isActive,
  isLoading,
  isDisabled,
  onClickCoupon,
  onClickButton
}) {
  const ICON_SYMBOL_MAP = {
    percentage: 'percent',
    money: 'dollar_sign'
  }

  const thumbResolver = src => {
    if (isLink(src)) {
      return <img src={src} alt={title} />
    }

    if (src) {
      return <IconDepartment name={src} />
    }

    return <Icon name="dollar_note" />
  }

  return (
    <S.Container>
      <S.Wrapper isActive={isActive} onClick={onClickCoupon}>
        <S.IconExtra>
          {giftedBy && (
            <Fragment>
              <S.IconReceived>
                <Icon name="received" fill="currentColor" />
              </S.IconReceived>
              <S.IconGift>
                <Icon name="gift" fill="currentColor" />
              </S.IconGift>{' '}
            </Fragment>
          )}
          {isShared && (
            <S.IconShare>
              <Icon name="share" fill="currentColor" data-icon="share" />
            </S.IconShare>
          )}
        </S.IconExtra>

        <S.GroupDescription>
          <S.Picture>
            <S.PictureImage>{thumbResolver(image)}</S.PictureImage>

            <S.PictureIcon>
              <Icon
                name={
                  isShared
                    ? ICON_SYMBOL_MAP.percentage
                    : ICON_SYMBOL_MAP[category]
                }
              />
            </S.PictureIcon>
          </S.Picture>

          <S.Title>
            <Text size="mega" align="center">
              {title}
            </Text>
          </S.Title>
          {description && (
            <S.Description>
              <Text size="kilo" align="center">
                {description}
              </Text>
            </S.Description>
          )}
        </S.GroupDescription>

        <S.Divider />
        <S.Bottom>
          <Button
            size="mega"
            color="purple"
            isDisabled={isDisabled}
            isLoading={isLoading}
            onClick={onClickButton}
            isStretch
          >
            {isActive
              ? (
              <Fragment>
                <S.ButtonIcon>
                  {isActive && <Icon name="checked" size="kilo" />}
                </S.ButtonIcon>

                <Text size="mega" noMargin>
                  {buttonText.active}
                </Text>
              </Fragment>
                )
              : (
              <Text size="kilo" noMargin>
                {buttonText.default}
              </Text>
                )}
          </Button>

          <S.TextFooter>
            <Text size="kilo" align="center" noMargin>
              {isActive ? footerText.active : footerText.default}
            </Text>
          </S.TextFooter>
        </S.Bottom>
      </S.Wrapper>
    </S.Container>
  )
}

CouponNew.propTypes = {
  image: PropTypes.string,
  title: PropTypes.string.isRequired,
  description: PropTypes.string,
  category: PropTypes.oneOf(['percentage', 'money']).isRequired,
  buttonText: PropTypes.shape({
    default: PropTypes.string,
    active: PropTypes.string
  }),
  footerText: PropTypes.shape({
    default: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
    active: PropTypes.oneOfType([PropTypes.node, PropTypes.string])
  }).isRequired,
  giftedBy: PropTypes.string,
  isShared: PropTypes.bool,
  isActive: PropTypes.bool,
  isLoading: PropTypes.bool,
  isDisabled: PropTypes.bool,
  onClickCoupon: PropTypes.func,
  onClickButton: PropTypes.func
}

CouponNew.defaultProps = {
  buttonText: {
    default: 'Ativar',
    active: 'Ativado'
  },
  isActive: false,
  isLoading: false,
  isDisabled: false
}

export default memo(CouponNew)
